import { render, staticRenderFns } from "./ResultsTravel.vue?vue&type=template&id=3379c040&"
import script from "./ResultsTravel.vue?vue&type=script&lang=js&"
export * from "./ResultsTravel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports